import "./all_case_view.css";

import { useFilters, useSortBy, useTable } from "react-table";

import React from "react";
import Table from "react-bootstrap/Table";
import { useUser } from "../../contexts/UserProvider";

export default function CaseTable({ columns, data, initialState, surveyed, onRowClick }) {
  const { user } = useUser();

  const shuffledData = React.useMemo(() => {
    if (!Array.isArray(data)) return [];
    const participantId = user?.id;
    const baseData =
      participantId === undefined || participantId === null
        ? data
        : shuffleWithSeed(data, createSeed(participantId));
    return baseData.map((item, index) => ({
      ...item,
      shuffled_case_number: index + 1,
    }));
  }, [data, user?.id]);

  // Use the useTable Hook to send the columns and data to build the table
  const {
    getTableProps, // table props from react-table
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    rows, // rows for the table based on the data passed
    prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
  } = useTable(
    {
      columns,
      data: shuffledData, // data: data, if not shuffled
      initialState: initialState,
    },
    useFilters,
    useSortBy
  );

  const disable = (row) => {
    return surveyed.includes(String(row.original.micro_id));
  };

  return (
    <Table 
      // striped 
      bordered 
      responsive 
      {...getTableProps()} 
      className="custom-table"
    >
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
              {...column.getHeaderProps(column.getSortByToggleProps())}
               style={column.style}
              >
                {column.render("Header")}
                <span>
                  {column.isSorted ? (column.isSortedDesc ? " ▼" : " ▲") : ""}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              onClick={() => onRowClick(row.original)}
              style={{ cursor: "pointer" }}
            >
              {row.cells.map((cell) => (
                <td {...cell.getCellProps()} onClick={(e) => {
                  if (cell.column.id === "micro_id") e.stopPropagation(); // Stop propagation only on the button cell
                }}>
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

// Helper functions to help shuffle cases deterministically
function createSeed(value) {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value >>> 0;
  }
  const str = String(value);
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = Math.imul(31, hash) + str.charCodeAt(i);
  }
  return hash >>> 0;
}

function shuffleWithSeed(items, seed) {
  const rng = mulberry32(seed);
  const result = items.slice();
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

function mulberry32(seed) {
  let t = seed || 1;
  return () => {
    t += 0x6d2b79f5;
    let x = Math.imul(t ^ (t >>> 15), t | 1);
    x ^= x + Math.imul(x ^ (x >>> 7), x | 61);
    return ((x ^ (x >>> 14)) >>> 0) / 4294967296;
  };
}